import { BreadcrumbType } from 'types';

import { formatSeasonLabel } from 'helpers/formatSeason';

import { routes } from 'data/routes';

export const buildCategoryBreadcrumbSecondary = (
  season: string,
  marketLine: string,
  genre: string,
  category: string,
  genreLabel: string,
  categoryLabel: string
): BreadcrumbType[] => [
  { label: formatSeasonLabel(season) },
  { label: marketLine },
  { label: genreLabel },
  { label: categoryLabel, to: `${routes.catalogue}/${genre}/${category}` },
];
